import React from 'react';
import { array, bool, func, shape, string } from 'prop-types';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';

import { BLANK_RULE_TEMPLATE_ID, resetRule } from '../../helpers/rules';
import RuleTemplateSelect from './RuleTemplateSelect';
import TextField from '../FormFields/TextField';
import Switch from '../FormFields/Switch';

import classes from './ModifyRuleFieldset.module.css';

const NewRuleFieldset = ({
    disabled,
    errors,
    onBlur,
    onChange,
    onPatch,
    readOnly,
    ruleTemplates,
    touched,
    values
}) => {
    function handleCustomizeChange(event) {
        event.stopPropagation();
        const { checked } = event.target;
        if (!checked) {
            const rule = resetRule(values.ruleTemplateId, ruleTemplates);
            onPatch(rule, { validateForm: true });
            return;
        }
        onChange(event);
        return;
    }

    const disableCustomize = disabled || values.ruleTemplateId === BLANK_RULE_TEMPLATE_ID;

    return (
        <>
            <RuleTemplateSelect
                error={errors.ruleTemplateId}
                disabled={disabled}
                onPatch={onPatch}
                ruleTemplates={ruleTemplates}
                touched={touched.ruleTemplateId}
                value={values.ruleTemplateId}
            />
            <List>
                <ListItem disableGutters>
                    <ListItemText
                        classes={{
                            primary: classes.listItemText
                        }}
                    >
                        Enabled
                    </ListItemText>
                    <ListItemSecondaryAction>
                        <Switch
                            checked={values.enabled}
                            disabled={disabled}
                            name="enabled"
                            onBlur={onBlur}
                            onChange={onChange}
                        />
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem disableGutters>
                    <ListItemText
                        classes={{
                            primary: classes.listItemText
                        }}
                    >
                        Customize
                    </ListItemText>
                    <ListItemSecondaryAction>
                        <Switch
                            checked={values.custom}
                            disabled={disableCustomize}
                            name="custom"
                            onBlur={onBlur}
                            onChange={handleCustomizeChange}
                        />
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem dense disableGutters>
                    <ListItemText>
                        <TextField
                            autoComplete="off"
                            disabled={disabled || !values.custom}
                            errors={errors.name}
                            fullWidth
                            helperText="Enable customization in order to give your rule a custom name"
                            label="Rule Name"
                            name="name"
                            onBlur={onBlur}
                            onChange={onChange}
                            touched={touched.name}
                            value={values.name}
                        />
                    </ListItemText>
                </ListItem>
            </List>
        </>
    );
};

NewRuleFieldset.defaultProps = {
    disabled:      false,
    errors:        {},
    ruleTemplates: {
        data: []
    },
    readOnly: false,
    touched:  {},
    values:   {}
};

NewRuleFieldset.propTypes = {
    disabled: bool,
    errors:   shape({
        name: string
    }),
    onBlur:        func,
    onChange:      func,
    readOnly:      bool,
    ruleTemplates: shape({
        data: array
    }),
    touched: shape({
        string: bool
    }),
    values: shape({
        custom:  bool,
        enabled: bool,
        name:    string
    })
};

export default NewRuleFieldset;
